var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "bg_img",
      style: { height: _vm.viewHeight },
      attrs: { id: "login-warp" },
    },
    [
      _c(
        "div",
        { attrs: { id: "login" } },
        [
          _c(
            "transition",
            {
              attrs: {
                name: _vm.settings.visible ? "slideleft" : "slideright",
              },
            },
            [
              _c("div", { staticClass: "login" }, [
                _c("div", [
                  _c("img", {
                    staticClass: "logo",
                    attrs: {
                      src: require("@/assets/qrcode_icon.png"),
                      alt: "logo",
                    },
                    on: {
                      click: function ($event) {
                        _vm.settings.useBarCode = !_vm.settings.useBarCode
                      },
                    },
                  }),
                ]),
                !_vm.settings.useBarCode
                  ? _c(
                      "div",
                      [
                        _c("div", { staticClass: "logo-info" }, [
                          _c("p", { staticClass: "name" }, [
                            _c("span", { staticClass: "sub" }, [
                              _vm._v("孤独症测评系统"),
                            ]),
                          ]),
                        ]),
                        _c(
                          "IForm",
                          {
                            ref: "login",
                            attrs: {
                              model: _vm.login,
                              elem: _vm.loginElem,
                              rules: _vm.loginRule,
                              "btn-loading": _vm.$store.state.app.loading,
                              submit: false,
                              "split-model": "24",
                            },
                            on: { "on-submit": _vm.toSubmit },
                          },
                          [
                            _c(
                              "Button",
                              {
                                style: {
                                  color: "#fff",
                                  background:
                                    !_vm.login.username || !_vm.login.password
                                      ? "#2d8cf080"
                                      : "#2d8cf0",
                                  "border-color":
                                    !_vm.login.username || !_vm.login.password
                                      ? "#2d8cf080"
                                      : "#2d8cf0",
                                },
                                attrs: {
                                  long: "",
                                  type: "primary",
                                  disabled:
                                    !_vm.login.username || !_vm.login.password,
                                },
                                on: { click: _vm.handleLogin },
                              },
                              [_vm._v("登录")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _c("div", [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/zyk_app.jpg"),
                          height: "295",
                          width: "295",
                        },
                      }),
                      _c("p", { staticClass: "version" }, [
                        _vm._v("扫码使用小程序"),
                      ]),
                    ]),
              ]),
              _vm.settings.visible ? _c("IConfig") : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("IError"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }